import { render } from "./stage-customer-type.component.vue?vue&type=template&id=796ef361&scoped=true"
import script from "./stage-customer-type.component.vue?vue&type=script&lang=js"
export * from "./stage-customer-type.component.vue?vue&type=script&lang=js"

import "./stage-customer-type.component.vue?vue&type=style&index=0&id=796ef361&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796ef361"]])

export default __exports__